/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

import { tProductKind, tProductWeight } from './product';

export const tBrandCondition = t.string;
export const tBrandIdCondition = t.number;

export const tKindCondition = t.intersection([
  t.type({ kind: tProductKind }),
  t.partial({ brand_subtype: t.string }),
  t.partial({ root_subtype: t.string }),
]);

export const tWeightCondition = tProductWeight;

export const tProductThresholdConditions = t.partial({
  maximum_price: t.union([t.number, t.undefined, t.null]),
  minimum_price: t.union([t.number, t.undefined, t.null]),
});
